import { privateApi } from "services/api/private";

export type OrganizationSettings = {
  firebolt_agent_enabled: boolean;
};

const LiteOrganizationSettings: OrganizationSettings = {
  firebolt_agent_enabled: false,
};

export const getOrganizationSettings =
  async (): Promise<OrganizationSettings> => {
    if (process.env.REACT_APP_LITE) {
      return LiteOrganizationSettings;
    }
    const { data } = await privateApi.get<{ settings: OrganizationSettings }>(
      "/organizationSettings"
    );
    return data.settings as OrganizationSettings;
  };

export const setOrganizationSetting = async (
  settingName: keyof OrganizationSettings,
  value: OrganizationSettings[keyof OrganizationSettings]
): Promise<void> => {
  if (process.env.REACT_APP_LITE) {
    return;
  }
  await privateApi.put(`/organizationSettings/${settingName}`, { value });
};
